import * as React from 'react';
import { MobilePreview, Course } from '../components/courses/MobilePreview';

const MobilePreviewExample: React.FC = () => {
  // Dados de exemplo com URLs reais do sistema
  const exampleCourses: Course[] = [
    {
      id: '1',
      title: 'Treino Funcional Avançado',
      description: 'Desenvolva força, resistência e coordenação com exercícios funcionais que simulam movimentos do dia a dia. Ideal para quem busca um treino completo e desafiador.',
      cover: { 
        uri: '/images/image-default-courses.png',
        uri_original: '/images/image-default-courses.png'
      },
      poster: { 
        uri: '/images/image-default-courses.png',
        uri_original: '/images/image-default-courses.png'
      }
    },
    {
      id: '2',
      title: 'Yoga para Iniciantes',
      description: 'Aprenda as posturas básicas do yoga, técnicas de respiração e meditação. Perfeito para quem está começando sua jornada no yoga.',
      cover: { 
        uri: '/images/image-default-courses-2.png',
        uri_original: '/images/image-default-courses-2.png'
      },
      poster: { 
        uri: '/images/image-default-courses-2.png',
        uri_original: '/images/image-default-courses-2.png'
      }
    },
    {
      id: '3',
      title: 'Musculação Feminina',
      description: 'Programa de musculação especialmente desenvolvido para mulheres, focando em força, tonificação e autoestima.',
      cover: { 
        uri: '/images/image-default-courses-3.png',
        uri_original: '/images/image-default-courses-3.png'
      },
      poster: { 
        uri: '/images/image-default-courses-3.png',
        uri_original: '/images/image-default-courses-3.png'
      }
    },
    {
      id: '4',
      title: 'HIIT Intensivo',
      description: 'Treino intervalado de alta intensidade para queimar gordura e melhorar o condicionamento físico em menos tempo.',
      cover: { 
        uri: '/images/image-default-courses-4.png',
        uri_original: '/images/image-default-courses-4.png'
      },
      poster: { 
        uri: '/images/image-default-courses-4.png',
        uri_original: '/images/image-default-courses-4.png'
      }
    },
    {
      id: '5',
      title: 'Pilates Clássico',
      description: 'Fortaleça seu core e melhore sua postura com os exercícios clássicos do método Pilates.',
      cover: { 
        uri: '/images/image-default-courses.png',
        uri_original: '/images/image-default-courses.png'
      },
      poster: { 
        uri: '/images/image-default-courses.png',
        uri_original: '/images/image-default-courses.png'
      }
    },
    {
      id: '6',
      title: 'Crossfit para Todos',
      description: 'Exercícios variados e desafiadores que trabalham todo o corpo. Adaptável para todos os níveis.',
      cover: { 
        uri: '/images/image-default-courses-2.png',
        uri_original: '/images/image-default-courses-2.png'
      },
      poster: { 
        uri: '/images/image-default-courses-2.png',
        uri_original: '/images/image-default-courses-2.png'
      }
    }
  ];

  const [selectedMode, setSelectedMode] = React.useState<'poster' | 'cover' | 'both'>('both');

  return (
    <div style={{ padding: '20px', backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '10px',
        padding: '30px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ 
          textAlign: 'center', 
          marginBottom: '20px',
          color: '#333',
          fontSize: '2.5rem',
          fontWeight: 'bold'
        }}>
          🎬 Preview Mobile Estilo Netflix
        </h1>
        
        <p style={{ 
          textAlign: 'center', 
          marginBottom: '30px',
          color: '#666',
          fontSize: '1.1rem',
          lineHeight: '1.6'
        }}>
          Visualize como suas imagens de <strong>cover</strong> e <strong>poster</strong> dos cursos 
          ficam em dispositivos móveis com layout responsivo estilo Netflix.
        </p>

        <div style={{ 
          backgroundColor: '#f8f9fa', 
          padding: '20px', 
          borderRadius: '8px',
          marginBottom: '30px',
          border: '1px solid #e9ecef'
        }}>
          <h3 style={{ marginTop: 0, color: '#495057' }}>📱 Características do Preview:</h3>
          <ul style={{ color: '#6c757d', lineHeight: '1.8' }}>
            <li><strong>Poster (2:3):</strong> Formato vertical otimizado para listas de cursos</li>
            <li><strong>Cover (16:9):</strong> Formato horizontal ideal para banners e destaques</li>
            <li><strong>Grid Responsivo:</strong> Adapta automaticamente ao tamanho da tela</li>
            <li><strong>Lazy Loading:</strong> Carregamento otimizado das imagens</li>
            <li><strong>Hover Effects:</strong> Animações suaves ao passar o mouse</li>
            <li><strong>Fallback Images:</strong> Imagens padrão caso falhe o carregamento</li>
          </ul>
        </div>

        <MobilePreview 
          courses={exampleCourses} 
          mode={selectedMode}
        />

        <div style={{ 
          marginTop: '40px',
          padding: '20px',
          backgroundColor: '#e7f3ff',
          borderRadius: '8px',
          border: '1px solid #b8daff'
        }}>
          <h3 style={{ marginTop: 0, color: '#004085' }}>💡 Como usar em sua aplicação:</h3>
          <pre style={{ 
            backgroundColor: '#f8f9fa',
            padding: '15px',
            borderRadius: '4px',
            overflow: 'auto',
            fontSize: '14px',
            border: '1px solid #dee2e6'
          }}>
{`import { MobilePreview } from '../components/courses/MobilePreview';

// Exemplo de uso básico
<MobilePreview courses={meusCursos} mode="poster" />

// Com dados do GraphQL
const { data } = useQuery(COURSES_QUERY);
<MobilePreview courses={data?.courses} mode="both" />`}
          </pre>
        </div>

        <div style={{ 
          marginTop: '20px',
          padding: '15px',
          backgroundColor: '#fff3cd',
          borderRadius: '8px',
          border: '1px solid #ffeaa7'
        }}>
          <p style={{ margin: 0, color: '#856404' }}>
            <strong>📌 Dica:</strong> O componente automaticamente usa imagens de exemplo caso não sejam fornecidos cursos,
            tornando fácil testar o layout antes de integrar com dados reais.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobilePreviewExample;
